// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dSve","left":"styles_left__2o0jR"};